import { render, staticRenderFns } from "./ThreeJs.vue?vue&type=template&id=0381577c&scoped=true&"
import script from "./ThreeJs.vue?vue&type=script&lang=js&"
export * from "./ThreeJs.vue?vue&type=script&lang=js&"
import style0 from "./ThreeJs.vue?vue&type=style&index=0&id=0381577c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0381577c",
  null
  
)

export default component.exports